<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ack"><a id="page_xi"></a><strong><span class="small">ACKNOWLEDGMENTS</span></strong></h2>
<p class="noindent">This book represents the experiences of two physicians and the journey they have taken in their profession. We have each had intense experience in our work in family practice, internal medicine, geriatrics, and medical ethics. We are especially grateful to our patients, whose life stories have been the single greatest educational lesson for us as physicians.</p>
<p class="indent">We also want to acknowledge our editor, Jacqueline Wehmueller, who agreed with us that recent national events made a second edition an essential project, so that the book might better aid people seeking help with their advance directives. We are most grateful for her contributions; this book is much enriched because she has been our editor.</p>
<p class="indent">Finally, we want to refer to our personal journeys through life. The events and experiences that we have each encountered have given direction to our work. Most of all we want to thank our families—our wives, Jeanne and Helen; our children, Caitlin, Alexander, and Christina Doukas, and Robert Reichel and Andrea Reichel Ruggeri—who were understanding and supportive while we wrote this book. We are grateful for their love, support, and graciousness, which allowed us to maintain our purpose and bring this work to fruition. Thank you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?2a0aff9c